import {languageProcessing} from '@axyseo/index.js';
const {AbstractResearcher} = languageProcessing;

// Import language-specific researchers
import EnglishResearcher from '../languageProcessing/languages/en/Researcher.js';
import ChineseResearcher from '../languageProcessing/languages/zh/Researcher.js';
import JapaneseResearcher from '../languageProcessing/languages/ja/Researcher.js';
import DefaultResearcher from '../languageProcessing/languages/_default/Researcher.js';

import isChineseText from '../languageProcessing/helpers/language/isChineseText';

/**
 * Detects the language of the given text and returns the appropriate researcher.
 *
 * @param {Paper} paper The paper object containing the text to analyze.
 * @param {string} [locale] Optional locale override.
 *
 * @returns {AbstractResearcher} The appropriate researcher for the detected language.
 */
export default function getLanguageResearcher(paper, locale = null) {
  // Use provided locale or try to get from paper
  const paperLocale = locale || (paper && paper.getLocale ? paper.getLocale() : '');

  // Get text from paper for language detection
  let text = '';
  if (paper) {
    const keyword = paper.getKeyword ? paper.getKeyword() : '';
    const title = paper.getTitle ? paper.getTitle() : '';
    const content = paper.getText ? paper.getText() : '';
    text = [keyword, title, content].join(' ');
  }

  // Explicit locale mapping
  if (paperLocale) {
    const languageCode = paperLocale.split('-')[0].toLowerCase();

    switch (languageCode) {
      case 'zh':
      case 'zh-cn':
      case 'zh-tw':
        return new ChineseResearcher(paper);
      case 'ja':
        return new JapaneseResearcher(paper);
      case 'en':
        return new EnglishResearcher(paper);
      default:
        // Continue to text-based detection
        break;
    }
  }

  // Text-based language detection
  if (isChineseText(text)) {
    return new ChineseResearcher(paper);
  }

  // Check for Japanese characters
  const japaneseRegex = /[\u3040-\u309f\u30a0-\u30ff\u4e00-\u9faf]/;
  if (japaneseRegex.test(text)) {
    return new JapaneseResearcher(paper);
  }

  // Default to English or provided locale
  if (paperLocale === 'en' || !paperLocale) {
    return new EnglishResearcher(paper);
  }

  // Fallback to default researcher
  return new DefaultResearcher(paper);
}
